import { isNotDefined } from '@sgme/fp';
import { FormattedMessage } from 'components/shared/Intl';
import type { IntlKey } from 'locales';
import { JSX } from 'react';

interface WarningProps {
  warningId: IntlKey | null | undefined;
}

export function Warning({ warningId }: WarningProps): JSX.Element | null {
  if (isNotDefined(warningId)) {
    return null;
  }

  return (
    <div className="fs-6 text-info text-end col-8">
      <i className="icon icon-sm">info_outline</i>
      <span className="align-middle">
        <FormattedMessage id={warningId} />
      </span>
    </div>
  );
}
